cb.define([], function () {
  var RM_rm_gatheringvouchlist_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
	  if(viewmodel.get('btnAdd') != null){
		  viewmodel.get('btnAdd').setVisible(false);
	  }
	  let gridModel = viewmodel.getGridModel();
	  gridModel.on('beforeLoad', function (data){
			var common = data.condition.commonVOs;
			data.isDistinct = true;
	  });
	  viewmodel.getGridModel().on('beforeLoad',function(data)
	  {
		
		if (data.condition)
		{
			debugger;
			data.condition['isExtend']=true;
			data.condition['simpleVOs']=[];		
			var simpleVOs=data.condition.simpleVOs;			
			var commonVOs=data.condition.commonVOs;
			for(var i=0;i<commonVOs.length;i++){
				if(commonVOs[i].itemName == 'fGatheringMoney'){
					var defwhere={};
					if(commonVOs[i].value1 == '1'){
						defwhere['field']=commonVOs[i].itemName;
						defwhere['value1']=0;
						defwhere['op']='gt';
					}else if(commonVOs[i].value1 == '2'){
						defwhere['field']=commonVOs[i].itemName;
						defwhere['value1']=0;
						defwhere['op']='lt';
					}else{
						data.condition['isExtend']=false;
					}
					
					commonVOs.splice(i,1); 
						//commonVOs.push(commonVOs[i]);
					simpleVOs.push(defwhere);					
				}
			}
			
			
			
		}

	  });
    },
 
  }
  try {
    module.exports = RM_rm_gatheringvouchlist_VM_Extend;
  } catch (error) {

  }
  return RM_rm_gatheringvouchlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_gatheringvouchlist_VM.Extend.js